export interface Article {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  date: string;
  readTime: string;
  imageUrl: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 1,
    title: '2026世界杯预选赛亚洲区：中国队关键战役深度前瞻',
    excerpt: '2026年世界杯亚洲区预选赛进入白热化阶段，中国队将在主场迎战关键对手。本文从战术体系、球员状态、历史交锋等多个维度进行全面分析。',
    content: `<p>2026年世界杯亚洲区预选赛已进入最为关键的冲刺阶段。中国国家男子足球队将在主场迎来一场决定出线命运的焦点战役。本场比赛的重要性不言而喻——胜则保留直接晋级希望，败则可能提前告别世界杯梦想。</p>
    <h2>战术体系分析</h2>
    <p>主教练在本届预选赛中逐步确立了以4-3-3为基础阵型的战术框架。中场的三人组配置兼顾了防守硬度和进攻创造力，前场三叉戟的速度与技术特点也得到了充分发挥。在最近的几场热身赛中，球队展现出了令人欣喜的传控能力和高位逼抢意识。</p>
    <p>特别值得关注的是双后腰的配置——一名偏向防守拦截，另一名负责组织调度，这种分工明确的搭配让球队在攻防转换中更加流畅。边后卫的插上助攻也成为球队进攻体系中不可或缺的一环。</p>
    <h2>核心球员状态</h2>
    <p>锋线核心在最近5场俱乐部赛事中打入4球并送出2次助攻，状态火热。中场组织核心的传球成功率达到惊人的91%，是球队进攻发起的节拍器。后防线上，门将的扑救成功率维持在85%以上，为球队提供了最后一道可靠屏障。</p>
    <h2>历史交锋与数据对比</h2>
    <p>两队近10次交锋中，中国队取得4胜3平3负的战绩，略占上风。在主场作战时，战绩更为出色——5次主场交锋取得3胜2平的不败战绩。控球率方面，中国队在本届预选赛中场均控球率达到54%，展现出了较强的控场能力。</p>
    <h2>预测与展望</h2>
    <p>综合各方面因素，本场比赛中国队占据天时地利人和的优势。如果能够在开场阶段迅速进入状态并取得进球，将极大提升球队信心。预计最终比分为2:1，中国队主场取胜。</p>`,
    category: 'football',
    categoryName: '足球',
    author: '张指导',
    date: '2026-08-06',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20football%20soccer%20match%20in%20modern%20stadium%20with%20dramatic%20stadium%20lighting%2C%20green%20grass%20field%2C%20athletes%20in%20red%20jerseys%20in%20action%2C%20cinematic%20sports%20photography%2C%20energetic%20atmosphere%2C%20warm%20golden%20evening%20light%2C%20editorial%20quality%2C%20dynamic%20composition&width=800&height=500&seq=article-football-1&orientation=landscape',
    tags: ['世界杯预选赛', '中国足球', '战术分析', '比赛预测'],
    featured: true,
  },
  {
    id: 2,
    title: 'NBA新赛季前瞻：东西部格局巨变与冠军热门深度解读',
    excerpt: 'NBA 2026-27赛季即将拉开帷幕，休赛期的重磅交易改变了联盟格局。哪些球队将成为新的冠军争夺者？本文带来全方位的赛季前瞻。',
    content: `<p>NBA 2026-27赛季即将在十月正式打响。经历了又一个疯狂的休赛期后，联盟的势力版图发生了显著变化。多支球队通过交易和选秀完成了阵容升级，新赛季的竞争格局令人充满期待。</p>
    <h2>东部格局分析</h2>
    <p>卫冕冠军在休赛期保持了核心阵容的稳定，同时通过自由市场补强了替补深度。他们的首发五人组依然是联盟最强的组合之一，场均得分能力和防守效率均位居联盟前列。</p>
    <p>最大的挑战者来自一支通过重磅交易得到全明星控卫的东部劲旅。这笔交易彻底改变了球队的进攻体系，新赛季他们有望从季后赛边缘球队一跃成为冠军争夺者。</p>
    <h2>西部格局分析</h2>
    <p>西部依旧是群雄逐鹿的格局。上赛季常规赛冠军保留了全部核心轮换，并在选秀中摘得一位潜力新星。另一支传统豪强通过自由市场签下了两位经验丰富的老将，为冲击总冠军做最后的补强。</p>
    <h2>MVP热门人选</h2>
    <p>上赛季MVP得主依然是最有力的竞争者，他在过去三个赛季中两次获奖，展现出了统治级的个人能力。国际球员的崛起也不容忽视，几位欧洲球星在新赛季有望创造历史。</p>
    <h2>赛季预测</h2>
    <p>综合各队阵容深度、教练团队和赛程难度，我们预测东部冠军将在卫冕冠军和新贵之间产生，西部则可能上演多支球队混战的局面。总冠军的归属，很可能取决于季后赛中的伤病情况和临场发挥。</p>`,
    category: 'basketball',
    categoryName: '篮球',
    author: '李明',
    date: '2026-08-05',
    readTime: '10分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20in%20modern%20indoor%20arena%20with%20dramatic%20spotlight%2C%20basketball%20players%20in%20orange%20jerseys%20dunking%2C%20energetic%20crowd%2C%20cinematic%20sports%20photography%2C%20warm%20arena%20lighting%2C%20editorial%20quality%2C%20dynamic%20action%20shot&width=800&height=500&seq=article-basketball-1&orientation=landscape',
    tags: ['NBA', '赛季前瞻', '篮球分析', '冠军预测'],
    featured: true,
  },
  {
    id: 3,
    title: '温网2026：草地之王争霸与新星崛起的时代',
    excerpt: '2026年温布尔登网球锦标赛精彩落幕，本届赛事见证了新老交替的关键时刻。年轻选手的惊艳表现让网坛格局发生了微妙变化。',
    content: `<p>2026年温布尔登网球锦标赛在全英草地俱乐部落下帷幕。为期两周的草地盛宴不仅奉献了多场经典对决，更见证了网球运动新老交替的历史性时刻。</p>
    <h2>男单赛场回顾</h2>
    <p>男单决赛堪称本届赛事最精彩的对决。卫冕冠军与新科世界第一展开了五盘大战，比赛耗时4小时12分钟，最终年轻选手在决胜盘以7-5险胜，首次捧起温网冠军奖杯。这场比赛被认为是草地网球史上最伟大的决赛之一。</p>
    <h2>女单赛场亮点</h2>
    <p>女单方面，一位年仅19岁的新星一路过关斩将，在半决赛中直落两盘击败世界排名第一的选手，决赛中又以6-3、6-4的比分轻松夺冠。她的发球速度和底线进攻能力令人惊叹，被广泛认为是女子网坛未来的统治者。</p>
    <h2>中国选手表现</h2>
    <p>中国选手在本届温网中取得了突破性成绩。女单选手闯入十六强，创造了个人大满贯最佳战绩。男双组合更是历史性地杀入四强，展现了亚洲网球水平的快速提升。</p>
    <h2>未来展望</h2>
    <p>随着新一代球员的崛起，职业网坛的竞争格局正在发生深远变化。传统的"三巨头"时代已成为历史，一个更加多元化和充满不确定性的新时代正在到来。</p>`,
    category: 'tennis',
    categoryName: '网球',
    author: '王教练',
    date: '2026-08-04',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20match%20on%20green%20grass%20court%20with%20bright%20natural%20sunlight%2C%20tennis%20player%20serving%20in%20white%20outfit%2C%20Wimbledon%20style%20elegant%20atmosphere%2C%20cinematic%20sports%20photography%2C%20editorial%20quality%2C%20dynamic%20action%20composition&width=800&height=500&seq=article-tennis-1&orientation=landscape',
    tags: ['温网', '网球大满贯', '草地网球', '新星崛起'],
    featured: false,
  },
  {
    id: 4,
    title: '英雄联盟S16全球总决赛：LPL赛区三强争霸格局解析',
    excerpt: 'S16全球总决赛即将开战，LPL赛区的三支代表队在夏季赛中展现出了截然不同的战术风格。谁最有可能问鼎召唤师杯？',
    content: `<p>英雄联盟S16全球总决赛的号角即将吹响。作为过去五年中三次夺冠的赛区，LPL的三支代表队承载着中国电竞爱好者的殷切期望。本文将从战术体系、选手状态和版本适应性三个维度，深度解析三支队伍的实力与前景。</p>
    <h2>一号种子：王者之师</h2>
    <p>夏季赛冠军以统治级的表现锁定了LPL一号种子的位置。他们在整个夏季赛中的胜率高达85%，展现出了无人能敌的竞技状态。上中野三人组的默契配合是队伍最强大的武器，场均15分钟经济领先达到2500金币。</p>
    <h2>二号种子：战术革新者</h2>
    <p>作为LPL赛区最具创新精神的队伍，二号种子在夏季赛中多次拿出非主流战术体系并取得奇效。他们的教练团队以大胆的BP策略著称，常常在关键比赛中祭出令人意想不到的英雄组合。</p>
    <h2>三号种子：黑马之姿</h2>
    <p>通过冒泡赛杀出重围的三号种子是本赛季最大的惊喜。一支在春季赛还处于中游的队伍，通过阵容调整和战术升级，在夏季赛季后赛中连克强敌。AD选手的出色发挥是队伍崛起的关键因素。</p>
    <h2>国际竞争格局</h2>
    <p>LCK赛区的冠军队伍依然是LPL最大的竞争对手。欧洲LEC赛区今年也展现出了强劲的竞争力。全球总决赛的舞台从来不缺少惊喜，LPL赛区需要在保持自信的同时做好充分准备。</p>`,
    category: 'esports',
    categoryName: '电竞',
    author: '电竞观察员',
    date: '2026-08-03',
    readTime: '9分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20with%20giant%20LED%20screens%20and%20colorful%20stage%20lighting%2C%20gaming%20competition%20stage%20with%20players%20at%20computers%2C%20massive%20crowd%20cheering%2C%20cinematic%20wide%20shot%2C%20energetic%20atmosphere%2C%20editorial%20photography%20quality&width=800&height=500&seq=article-esports-1&orientation=landscape',
    tags: ['英雄联盟', 'S16', 'LPL', '电竞赛事'],
    featured: true,
  },
  {
    id: 5,
    title: '欧冠小组赛抽签结果出炉：死亡之组再度降临',
    excerpt: '2026-27赛季欧冠小组赛抽签仪式在摩纳哥举行，多家豪门遭遇强敌。死亡之组的话题再次成为球迷关注的焦点。',
    content: `<p>2026-27赛季欧洲冠军联赛小组赛抽签仪式在摩纳哥格里马尔迪会议中心举行。32支晋级正赛的球队被分为8个小组，其中不乏令人血脉偾张的强强对话。</p>
    <h2>死亡之组分析</h2>
    <p>B组无疑是本届欧冠最具看点的"死亡之组"。上赛季欧冠冠军、英超亚军、意甲冠军和德甲季军被分在同一小组。四支球队的总身价超过25亿欧元，每一场比赛都将是顶级水平的较量。</p>
    <h2>各小组形势</h2>
    <p>A组由卫冕冠军领衔，出线形势相对明朗。C组则是技术流球队的聚集地，三支以传控见长的球队将展开风格相近的较量。D组中，一支时隔20年重返欧冠的老牌劲旅成为了最大的变数。</p>
    <h2>中国球员关注</h2>
    <p>值得关注的是，一名中国球员所在的球队成功晋级正赛。如果他能够在小组赛中获得出场机会，将成为继前辈之后又一位亮相欧冠赛场的中国球员。</p>
    <h2>赛程与展望</h2>
    <p>小组赛将于9月中旬正式打响，12月初结束。密集的赛程将考验各支球队的阵容深度和轮换策略。淘汰赛阶段的抽签将在12月中旬进行。</p>`,
    category: 'football',
    categoryName: '足球',
    author: '张指导',
    date: '2026-08-02',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=UEFA%20Champions%20League%20trophy%20with%20star%20soccer%20ball%20on%20dark%20elegant%20background%2C%20dramatic%20spotlight%20on%20trophy%2C%20premium%20sports%20photography%2C%20golden%20and%20navy%20color%20scheme%2C%20editorial%20quality%2C%20luxurious%20atmosphere&width=800&height=500&seq=article-football-2&orientation=landscape',
    tags: ['欧冠', '抽签', '死亡之组', '足球赛事'],
    featured: false,
  },
  {
    id: 6,
    title: 'CBA新赛季外援政策调整：对中国篮球发展的深远影响',
    excerpt: 'CBA联盟宣布2026-27赛季外援使用政策重大调整，四节四人次变为四节六人次。这一变化将如何影响联赛格局和中国篮球的未来？',
    content: `<p>CBA联盟在最新召开的会议上正式通过了外援使用政策的调整方案。从2026-27赛季开始，外援使用将从现行的四节四人次调整为四节六人次，这一重大变化在篮球圈内引发了广泛讨论。</p>
    <h2>政策变化要点</h2>
    <p>新政策的核心变化是每场比赛外援累计出场时间的大幅增加。在四节六人次的框架下，球队可以在每一节比赛中同时派上两名外援，这将极大提升比赛的竞技水平和观赏性。同时，联盟保留了末节单外援的限制，以保障关键时刻本土球员的参与度。</p>
    <h2>对各队影响</h2>
    <p>对于财力雄厚的顶级球队来说，新政策让他们可以更充分地利用外援资源。而对于中小球队而言，如何在外援投入和本土培养之间找到平衡将是一个难题。一些依靠本土球员深度取胜的球队可能需要调整建队策略。</p>
    <h2>本土球员发展</h2>
    <p>外援出场时间的增加在一定程度上压缩了本土球员的成长空间。但从另一个角度看，与高水平外援同场竞技也是提升本土球员能力的有效途径。联盟同时推出了配套的青训激励政策，鼓励各队加大年轻球员培养力度。</p>
    <h2>国际比较</h2>
    <p>与世界主流联赛相比，CBA的外援政策仍然相对保守。欧洲篮球联赛对非欧盟球员的限制、NBA的国际球员政策都为中国篮球提供了可借鉴的经验。</p>`,
    category: 'basketball',
    categoryName: '篮球',
    author: '李明',
    date: '2026-08-01',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20in%20Chinese%20arena%20with%20red%20and%20gold%20team%20colors%2C%20players%20in%20intense%20competition%2C%20dramatic%20indoor%20lighting%2C%20packed%20stadium%20atmosphere%2C%20cinematic%20sports%20photography%2C%20editorial%20quality&width=800&height=500&seq=article-basketball-2&orientation=landscape',
    tags: ['CBA', '外援政策', '篮球联赛', '中国篮球'],
    featured: false,
  },
  {
    id: 7,
    title: '美网2026：硬地赛季收官之战，谁将笑傲法拉盛？',
    excerpt: '美国网球公开赛作为年度最后一项大满贯赛事，承载着选手们全年的期待。硬地之王的称号将花落谁家？',
    content: `<p>2026年美国网球公开赛即将在纽约法拉盛公园拉开帷幕。作为年度第四项也是最后一项大满贯赛事，美网不仅是选手们争夺荣誉的舞台，更是全年ATP和WTA排名争夺的收官之战。</p>
    <h2>男单争冠形势</h2>
    <p>世界排名前三的选手在本赛季各赢下一项大满贯，美网将成为他们争夺年终世界第一的关键战役。硬地是这三位选手最擅长的场地类型，三人的美网历史战绩也相当亮眼。</p>
    <h2>女单格局</h2>
    <p>女子网坛今年呈现出罕见的"群芳争艳"局面，前四项大赛产生了四位不同的冠军。美网很可能延续这一趋势，多位选手都有夺冠实力。</p>
    <h2>中国军团</h2>
    <p>中国选手在硬地赛场上具备一定的竞争力。几位选手在北美硬地热身赛中表现不俗，有望在美网取得突破性成绩。双打项目更是中国军团的传统优势。</p>
    <h2>赛事看点</h2>
    <p>法拉盛公园的夜场比赛历来是最具观赏性的网球体验之一。阿瑟·阿什球场的灯光和纽约的能量，将为全球网球迷献上一场视觉盛宴。</p>`,
    category: 'tennis',
    categoryName: '网球',
    author: '王教练',
    date: '2026-07-30',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=US%20Open%20tennis%20stadium%20at%20night%20with%20dramatic%20court%20lighting%2C%20blue%20hard%20court%20surface%2C%20packed%20stadium%20crowd%2C%20New%20York%20tennis%20atmosphere%2C%20cinematic%20sports%20photography%2C%20editorial%20quality%2C%20energetic%20night%20scene&width=800&height=500&seq=article-tennis-2&orientation=landscape',
    tags: ['美网', '大满贯', '硬地网球', '法拉盛'],
    featured: false,
  },
  {
    id: 8,
    title: 'CS2 Major赛事：亚洲战队首次闯入四强创历史',
    excerpt: '在刚刚结束的CS2 Major赛事中，一支来自亚洲的战队创造了历史——首次闯入Major四强。这是亚洲CS发展的重要里程碑。',
    content: `<p>在本届CS2 Major锦标赛中，一支亚洲战队以令人惊叹的表现一路过关斩将，最终闯入四强，创造了亚洲CS历史上的最佳战绩。这一突破性成就不仅点燃了亚洲CS爱好者的热情，也为整个亚洲电竞产业注入了强劲动力。</p>
    <h2>晋级之路</h2>
    <p>从挑战者组起步的他们，在小组赛阶段就展现出了令人印象深刻的实力。以3胜1负的战绩晋级传奇组后，他们又接连击败了两支欧洲劲旅。四分之一决赛中面对世界排名第三的对手，他们打满三图最终以2:1取胜。</p>
    <h2>战术亮点</h2>
    <p>这支战队的成功绝非偶然。他们的战术体系融合了亚洲电竞特有的纪律性和欧洲CS的灵活性。在Inferno和Mirage两张地图上的胜率高达75%，堪称世界顶级水准。</p>
    <h2>选手表现</h2>
    <p>战队核心狙击手在本次赛事中的Rating达到1.24，位居所有选手第五位。指挥的战术布置多次在关键回合中取得奇效，被认为是本次赛事最佳IGL之一。</p>
    <h2>行业影响</h2>
    <p>这一历史性突破预计将为亚洲CS生态带来深远影响。更多的赞助商开始关注亚洲CS战队，年轻选手的成长路径也变得更加清晰。</p>`,
    category: 'esports',
    categoryName: '电竞',
    author: '电竞观察员',
    date: '2026-07-28',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=CS2%20esports%20tournament%20stage%20with%20players%20competing%20on%20computers%2C%20giant%20screen%20displaying%20game%20action%2C%20dramatic%20stage%20lighting%20with%20red%20and%20white%20colors%2C%20packed%20arena%2C%20cinematic%20photography%2C%20editorial%20quality&width=800&height=500&seq=article-esports-2&orientation=landscape',
    tags: ['CS2', 'Major', '亚洲电竞', 'FPS'],
    featured: false,
  },
  {
    id: 9,
    title: '中超联赛下半程：争冠与保级形势全景分析',
    excerpt: '2026赛季中超联赛赛程过半，争冠集团与保级军团的格局逐渐明朗。本文对各队下半程的形势进行全面解读。',
    content: `<p>2026赛季中超联赛已完成15轮较量，赛程正式过半。积分榜上的格局已经初步显现，争冠和保级的形势也日趋明朗。</p>
    <h2>争冠集团</h2>
    <p>目前积分榜前三名的球队之间仅有3分差距，争冠悬念十足。卫冕冠军以38分领跑，展现出卫冕的决心和实力。紧随其后的两支球队分别积36分和35分，三强之间的直接对话将直接决定冠军归属。</p>
    <h2>亚冠资格争夺</h2>
    <p>第四至第七名的四支球队积分差距在5分以内，亚冠资格的争夺同样激烈。这几支球队在下半程的表现将决定谁能够代表中国足球出征亚洲赛场。</p>
    <h2>保级大战</h2>
    <p>积分榜后四名的球队中，有两支传统劲旅的处境令人意外。主力球员伤病和赛季初引援不力是导致他们陷入困境的主要原因。保级大战往往比争冠更加残酷。</p>
    <h2>下半程展望</h2>
    <p>夏季转会窗口的运作将对各队下半程的表现产生重要影响。同时，亚冠赛事的分心也可能成为争冠球队的变数。中超联赛的精彩程度在不断提升。</p>`,
    category: 'football',
    categoryName: '足球',
    author: '张指导',
    date: '2026-07-25',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20Super%20League%20football%20match%20in%20modern%20stadium%20with%20red%20banners%20and%20passionate%20fans%2C%20players%20in%20red%20and%20white%20jerseys%2C%20dramatic%20evening%20lighting%2C%20cinematic%20sports%20photography%2C%20editorial%20quality&width=800&height=500&seq=article-football-3&orientation=landscape',
    tags: ['中超', '足球联赛', '争冠', '保级'],
    featured: false,
  },
  {
    id: 10,
    title: 'FIBA世界杯预选赛：中国男篮新阵容首次亮相表现亮眼',
    excerpt: '中国男篮在FIBA世界杯预选赛窗口期迎来了新一代球员的亮相。新阵容展现出令人耳目一新的比赛风格和精神面貌。',
    content: `<p>FIBA篮球世界杯预选赛亚洲区比赛在本窗口期进行了两轮较量。中国男篮以全新阵容出战，取得了1胜1负的战绩，比赛内容和精神面貌都令人欣慰。</p>
    <h2>新阵容特点</h2>
    <p>新任主教练带来的战术体系强调快速转换和空间篮球。与以往以内线为核心的打法不同，新阵容更加注重外线投射和球员的全面性。两场比赛场均三分出手次数达到32次，命中率保持在38%以上。</p>
    <h2>年轻球员表现</h2>
    <p>几名首次代表国家队出战的年轻球员表现可圈可点。一位22岁的锋线球员在两场比赛中场均贡献14.5分和6个篮板，展现出了超越年龄的成熟。</p>
    <h2>存在问题</h2>
    <p>防守端的协防意识和篮板保护仍有提升空间。第二场失利的比赛中，球队在第四节的关键时刻出现了几次防守失误。这些都是年轻球队成长过程中必须经历的阵痛。</p>
    <h2>出线前景</h2>
    <p>目前中国男篮在小组中排名第三，依然掌握着出线主动权。接下来两个窗口期的比赛将直接决定最终命运。</p>`,
    category: 'basketball',
    categoryName: '篮球',
    author: '李明',
    date: '2026-07-22',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20national%20basketball%20team%20in%20red%20jerseys%20playing%20international%20game%2C%20modern%20basketball%20arena%2C%20dramatic%20sports%20lighting%2C%20team%20huddle%20moment%2C%20cinematic%20photography%2C%20editorial%20quality%2C%20patriotic%20atmosphere&width=800&height=500&seq=article-basketball-3&orientation=landscape',
    tags: ['中国男篮', 'FIBA', '世界杯预选赛', '篮球'],
    featured: false,
  },
];

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.category === categorySlug);
}

export function getArticleById(id: number): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.featured);
}

export function getRelatedArticles(article: Article, count: number = 4): Article[] {
  return articles
    .filter((a) => a.id !== article.id && a.category === article.category)
    .slice(0, count);
}